import React, { useState } from 'react';
import { Row, Col, Divider, Button } from 'antd';
import { ShoppingCartOutlined } from '@ant-design/icons';
import { formatPrice } from '../../../../utils/utils';
import {
  summaryListItem,
  summaryListItemTitle,
  summaryListTitle,
  summaryListItemPrice,
} from '../styles';
import { disclaimerStyle } from '../../../UI/Disclaimer';
import { List } from '../../../../types/summary';

interface ListProps {
  list: List;
  showPrice?: boolean;
  showTotal?: boolean;
  disclaimer?: string;
}

const LinesList: React.FC<ListProps> = ({
  list,
  showPrice = true,
  showTotal = true,
  disclaimer = '',
}) => {
  const [hovered, setHovered] = useState('');

  return (
    <Col span={24}>
      <Row gutter={[16, 16]} justify="space-around" align="middle">
        <Col span={24} md={20}>
          <span style={summaryListTitle}>{list.title}</span>
        </Col>

        <Col span={24} md={20}>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {list.data.map((item, index) => (
              <li
                onMouseEnter={() => setHovered(`lines-${list.title}-${index}`)}
                onMouseLeave={() => setHovered('')}
                style={summaryListItem}
                key={`lines-${list.title}-${index}`}>
                <span style={summaryListItemTitle} title={item.title}>
                  {item.title}
                </span>
                <span style={summaryListItemPrice}>
                  {showPrice ? <>${formatPrice(item.price)}</> : '*'}
                  {item.type === 'materials' && (
                    <Button
                      type="primary"
                      icon={<ShoppingCartOutlined />}
                      href={item.url}
                      disabled={!item.url}
                      target="_blank"
                      style={{ marginLeft: '10px' }}>
                      {hovered === `lines-${list.title}-${index}` && item.url
                        ? 'Check in store'
                        : ''}
                    </Button>
                  )}
                </span>
              </li>
            ))}
          </ul>
        </Col>

        {showTotal && (
          <Col span={24} md={20}>
            <Divider style={{ margin: 0 }} />
            <Row justify="space-between">
              <span style={summaryListItemTitle}>Total {list.title}</span>
              <span style={summaryListItemPrice}>
                ${formatPrice(list.price || 0)}
                {disclaimer && '*'}
              </span>
            </Row>
          </Col>
        )}

        {disclaimer && (
          <Col span={24} md={20}>
            <span style={{ ...disclaimerStyle, textAlign: 'left' }}>
              *Prices vary depending on location.
            </span>
          </Col>
        )}
      </Row>
    </Col>
  );
};

export default LinesList;
